import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { IconButton, Tooltip, Typography } from '@mui/material'
import type { IconButtonProps } from '@mui/material/IconButton'
import React, { type ReactNode } from 'react'

interface TooltipLabelIconProps {
  className?: string
  tooltip: string | ReactNode
  size?: IconButtonProps['size']
}

export const TooltipLabelIcon = ({
  className,
  tooltip,
  size
}: TooltipLabelIconProps): JSX.Element => {
  const tooltipContent: ReactNode =
    typeof tooltip === 'string'
      ? (
        <Typography>
          {tooltip.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </Typography>
        )
      : (
          tooltip
        )

  return (
    <Tooltip title={tooltipContent}>
      <span><IconButton size={size} aria-label='help' className={className}>
        <HelpOutlineIcon fontSize='inherit' />
      </IconButton></span>
    </Tooltip>
  )
}
